import { Actions } from '../../interfaces'
import { AttributeView } from '@/entities/public'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { AttributeView },
  actions: { [AttributeView.name]: actions },
}
